import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

const BASE_URL = process.env.REACT_APP_BASE_URL || "http://localhost:5000";
function BrowsePortfolio() {
  const [posts, setPosts] = useState([]);
  const [fetchingErr, setFetchingErr] = useState(null);
  const [searchValue, setSearchValue] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    fetch(`${BASE_URL}/api/portfolio/getposts`)
      .then((response) => {
        if (!response.ok) {
          throw new Error("Failed to fetch posts");
        }
        return response.json();
      })
      .then((data) => {
        const normalizedData = data.map((post) => ({
          ...post,
          featureImage: Array.isArray(post.featureImage)
            ? post.featureImage
            : post.featureImage
            ? [post.featureImage]
            : [],
        }));
        setPosts(normalizedData);
        setLoading(false);
      })
      .catch((error) => {
        setFetchingErr(error.message);
        setLoading(false);
      });
  }, []);

  const handleDelete = (postId) => {
    fetch(`${BASE_URL}/api/portfolio/deletepost/${postId}`, {
      method: "DELETE",
    })
      .then((response) => {
        if (response.ok) {
          setPosts(posts.filter((post) => post._id !== postId));
          alert("Post Deleted");
        } else {
          throw new Error("Failed to delete post");
        }
      })
      .catch((error) => alert(`Failed to Delete: ${error.message}`));
  };

  const handleSearch = () => {
    if (!posts || !searchValue) return posts;
    return posts.filter((post) =>
      post.name?.toLowerCase().includes(searchValue.toLowerCase())
    );
  };

  return (
    <div className="container py-4">
      <div className="row mb-4">
        <div className="col-md-6 mx-auto">
          <div className="input-group">
            <input
              type="text"
              className="form-control shadow-sm"
              placeholder="Search Portfolio by Title..."
              value={searchValue}
              onChange={(e) => setSearchValue(e.target.value)}
              style={{
                borderRadius: "6px",
                borderColor: "#d0d5dd",
                padding: "0.65rem 0.85rem",
                fontSize: "16px",
                boxShadow: "0 2px 8px rgba(37,99,235,0.07)",
              }}
            />
          </div>
        </div>
      </div>
      <div className="row g-4 justify-content-center">
        {loading ? (
          <div className="col-12 text-center py-5">
            <div className="spinner-border text-primary" role="status"></div>
          </div>
        ) : fetchingErr ? (
          <div className="col-12 text-danger text-center py-5">{fetchingErr}</div>
        ) : (
          <>
            {handleSearch().length > 0 ? (
              handleSearch().map((post) => (
                <div className="col-md-4 d-flex align-items-stretch" key={post._id}>
                  <div className="card h-100 shadow-sm border-0">
                    <div className="position-relative">
                      {post.featureImage && post.featureImage.length > 0 ? (
                        <img
                          src={post.featureImage[0]}
                          alt="Portfolio thumbnail"
                          className="card-img-top"
                          style={{ height: "200px", objectFit: "cover" }}
                          onError={(e) => (e.target.src = "/fallback-image.jpg")}
                        />
                      ) : (
                        <div
                          className="d-flex align-items-center justify-content-center bg-light"
                          style={{ height: "200px" }}
                        >
                          <span className="text-muted">No Image Available</span>
                        </div>
                      )}
                      <span
                        className="badge bg-primary position-absolute top-0 start-0 m-2 text-capitalize"
                        style={{ fontSize: "0.95rem", padding: "0.5em 1em", opacity: 0.95 }}
                      >
                        {post.category}
                      </span>
                      {post.featureImage.length > 1 && (
                        <span className="badge bg-info position-absolute top-0 end-0 m-2">
                          +{post.featureImage.length - 1} more
                        </span>
                      )}
                    </div>
                    <div className="card-body d-flex flex-column">
                      <h5 className="card-title mb-2">{post.name}</h5>
                      <p className="card-text text-secondary mb-1">{post.taglineDesc}</p>
                      <div className="d-flex justify-content-end gap-2 mt-auto">
                        <Link to={`/portfolio/${post._id}`}>
                          <button
                            className="btn btn-outline-primary btn-sm"
                            data-bs-toggle="tooltip"
                            data-bs-placement="top"
                            title="Edit"
                          >
                            <i className="bi bi-pencil-square"></i>
                          </button>
                        </Link>
                        <button
                          className="btn btn-outline-danger btn-sm"
                          onClick={() => handleDelete(post._id)}
                          data-bs-toggle="tooltip"
                          data-bs-placement="top"
                          title="Delete"
                        >
                          <i className="bi bi-trash"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <div className="col-12 text-center mt-5">
                {searchValue ? (
                  <div className="alert alert-warning">Oops! No posts found.</div>
                ) : null}
                {posts.length === 0 ? (
                  <div className="alert alert-info">
                    The post bucket is empty, please create posts.
                  </div>
                ) : null}
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
}

export default BrowsePortfolio;
